import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { bonuses } from '../../data/bonuses';
export function Bonuses() {
  return <section className="bg-paper px-3 py-16 sm:px-4 sm:py-20" data-id="element-114" data-mp="1clpk2p8rc6uk">
      <div className="mx-auto max-w-4xl" data-id="element-115" data-mp="18k49xbnly6o2">
        <div className="px-1" data-id="element-116" data-mp="18lfh7lg9hwjx">
          <SectionHeading kicker="Exclusive bonuses" title={<>
                And today, I'm giving you <em className="text-cta" data-id="element-118" data-mp="20aihkq512mra">5 bonus resources free</em>
              </>} data-id="element-117" data-mp="259v4tbzt9vue" />
          <p className="mx-auto mt-5 flex w-fit items-center gap-2 rounded-full bg-blush px-4 py-2 text-sm font-bold text-rose" data-id="element-119" data-mp="1w8446lk4of7e">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-120" data-mp="1r9sp9wez7eib" />
            $147 value — included free
          </p>
        </div>

        <ol className="mt-10 space-y-6" data-id="element-121" data-mp="fux6by9aqqvy">
          {bonuses.map(b => <li key={b.number} className="overflow-hidden rounded-3xl border border-sand bg-cream" data-id="element-122" data-mp="fx05b7sffuct">
              <div className="flex items-center justify-between gap-3 bg-forest px-4 py-3 sm:px-6" data-id="element-123" data-mp="1erk9wrz97w2r">
                <span className="text-sm font-extrabold uppercase tracking-[0.14em] text-cream" data-id="element-124" data-mp="1jqneycf8i2aq">Bonus #{b.number}</span>
                <span className="text-sm font-bold text-cream" data-id="element-125" data-mp="1artdo8qyknqu">
                  <s className="text-cream/60" data-id="element-126" data-mp="1aq8l2oo7fevm">${b.value}</s> <span className="ml-1 rounded-md bg-cta px-2 py-0.5 text-white" data-id="element-127" data-mp="w2ngsrflf9m4">FREE TODAY</span>
                </span>
              </div>
              <img src={b.image} alt={`${b.title} mockup`} className="block w-full bg-white" loading="lazy" data-id="element-128" data-mp="10vgl5e75gfxo" />
              <div className="px-4 pb-6 pt-5 sm:px-7" data-id="element-129" data-mp="n4buh1lrexzh">
                <h3 className="font-serif text-2xl font-bold leading-tight text-forest sm:text-3xl" data-id="element-130" data-mp="r3kj5s1y05o6">{b.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-ink/85" data-id="element-131" data-mp="d5cjvdhfos9u">{b.intro}</p>
                <p className="mt-5 text-xs font-bold uppercase tracking-[0.14em] text-cta" data-id="element-132" data-mp="i3nrdhk9aqow">{b.listLabel}</p>
                <ul className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2" data-id="element-133" data-mp="2jtlk3ofuc0i2">
                  {b.items.map(item => <li key={item} className="flex items-start gap-2 text-[15px] text-ink" data-id="element-134" data-mp="2f11xk1z6dv14">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-135" data-mp="2b11h6bsin9rf" />
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 border-t border-sand pt-4 font-serif text-lg font-semibold italic text-forest" data-id="element-136" data-mp="32qw7aao773h5">{b.closing}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-10 px-1" data-id="element-137" data-mp="2tpg6mun6qfq4">
          <CTAButton label="Yes! Give me all 5 bonuses free" note="Bonuses included only with today's offer" data-id="element-138" data-mp="2tskjshimolsx" />
        </div>
      </div>
    </section>;
}